import { FC } from "react";
import { useAppDispatch } from "src/hooks";
import "src/styles/profile.css";
import React, { useState, useEffect } from "react";
import { useAppSelector } from './../../hooks';
import Asynchronous from '../../components/jsx_components/Autocomplete';
import { ContactsTable } from '../../components/jsx_components/ContactsTable';
import { clientsData } from './../../features/clients/clientsActions';
import { contactsData, contactsDataDeleteByID } from './../../features/contacts/contactsActions';
import Button from "@mui/material/Button";
import { PhoneArr, EmailArr, Client, Contact, ClientWithID, ContactWithID } from '../../types/request.type';

import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import { Box } from "@mui/material";
import ContactsTablePagination from "src/components/jsx_components/ContactsTablePagination";



export const ContactsPage: FC = () => {


  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [phone, setPhone] = useState<PhoneArr>([]);

  const [email, setEmail] = useState<EmailArr>([]);

  const [loading, setLoading] = React.useState(true);

  const [clientEmpty, setClientEmpty] = useState<ClientWithID>({ id: 777777, title: "FAKE" });

  const [position, setPosition] = useState<string>("");
  const [comment, setComment] = useState<string>("");


  const [selectedRows, setSelectedRows] = React.useState<number[]>([]);

  //Клиенты и контакты 1
  const selectedRow = (childdata1: number[]) => {
    setSelectedRows(childdata1);

  };


  const [isValidPhone0, setIsValidPhone0] = useState<boolean>(false);
  const [isValidEmail0, setIsValidEmail0] = useState<boolean>(false);

  // Клиенты
  const [clients1, setClients1] = useState<Client>("");
  const [clients1_id, setClients1_id] = useState<ClientWithID>();

  //Контакты
  const [contacts2, setContacts2] = useState<Contact>("");
  const [contacts2_id, setContacts2_id] = useState<ContactWithID>(null);

  //Need refresh
  const [needRefresh, setNeedRefresh] = useState<boolean>(false);


  //Клиенты
  const childToParent1_clients = (childdata1: Client) => {
    setClients1(childdata1);
    setPhone([]);
    setEmail([]);
    setContacts2("");
  };

  const childToParent1_id_clients = (childdata1: ClientWithID) => {
    setClients1_id(childdata1);
    setPhone([]);
    setEmail([]);
    setContacts2_id(null);
    setPosition("");
    setComment("");
  };

  /////////////////////////////////////////////////////////////////////////////////////

  //Клиенты
  const childToParent3_delete = (update_contact: boolean) => {

    setNeedRefresh(update_contact);

    if (update_contact) {

      setPhone([]);
      setEmail([]);
      setContacts2("");
      setContacts2_id(null);
      setPosition("");
      setComment("");

    }

  };

  ////////////////////////////////////////////////////////////////////////////////////

  const [parentToChild, setParentToChild] = useState("field");

  // Parent To Child
  const handleParentToChild = () => {
    setParentToChild("This data is coming from Parent");
  };

  //То что в компоненты идет

  const { dataClients } = useAppSelector((state) => state.clients);
  const { dataContacts } = useAppSelector((state) => state.contacts);

  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      console.log('page loaded');
      
      setTimeout(() => {
        setLoading(false);
      }, 1000);

      // do something else
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => {window.removeEventListener('load', onPageLoad);}
    }
  }, []);





  //Клиенты
  useEffect(() => {
   
    dispatch(clientsData()); // то что в экшине

   }, [dispatch]);


  //Все контакты
  useEffect(() => {
    
    // dispatch(contactsData3()); // то что в экшине !!!!!!!!!!!!!
    dispatch(contactsData(clientEmpty)); // то что в экшине

  }, [dispatch]);

  //Контакты
  useEffect(() => { 

   /* if (clients1_id?.id) {

      console.log("111");

      dispatch(contactsData(clients1_id)); // то что в экшине

    } else {

      if (!clients1_id) {

        console.log("222");

        dispatch(contactsData(clientEmpty)); // то что в экшине

      }
    }*/
  }, [clients1_id, dispatch]);


  return (

    <div className="main-page" style={{ height: "700px", width: 'auto', position: 'absolute', left: '0px', top: '0px' }}>

     {( loading) && (
         <Box>
          <CircularProgress
            size={200}
            sx={{
              color: green[500],
              position: 'absolute',
              top: '40%',
              left: '50%',
              width: '100px',
              height: '100px',
            }}
          />
          </Box>
        )}



      <Asynchronous
        key={"child1"}
        clear={false}
        sx={{ display: "block", height: "55px", marginTop: "0px", width: 500 }}
        childToParent={childToParent1_clients}
        childToParent_id={childToParent1_id_clients}
        dataParentToChild={handleParentToChild}
        value2={""}

        dataRows={
          dataClients?.payload?.list
            ? dataClients?.payload?.list.map((option) => ({
              id: option.id,
              label: option["title"] + "",
            }))
            : []
        }
        field={"label"}
        name={"Клиент"}
        freesl={false}
      />

      <br></br>

      <div style={{ height: "800px", width: "100%", left: '730px', top: '15px' }}>
        
        
      {/*<ContactsTable sx={{}} rows={dataContacts?.payload} clients1_id={clients1_id} childToParent={childToParent3_delete} selectedRow={selectedRow}/>*/}

      <ContactsTablePagination clients1_id={clients1_id} childToParent={childToParent3_delete} selectedRow={selectedRow}/>


      </div>




      <Button
        sx={{

          color: "white",
          backgroundColor: "#16b8f3",
          orderTop: 20,
          left: 10,
          height: 40,
          position: "absolute",
          // transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {

          let currentRowId = 0;
          navigate(`/contacts/${currentRowId}`);

        }}
      >
        Создать контакт
      </Button>


      {selectedRows.length === 1 ?
        <Button
          sx={{

            color: "white",
            backgroundColor: "#16b8f3",
            orderTop: 20,
            left: 190,
            height: 40,
            position: "absolute",
            // transform: "translateY(-50%)",

            "&:hover": {
              backgroundColor: "#12a8df",
            },
          }}
          variant="contained"
          onClick={() => {
            //navigate('/create-requests');

            let currentRowId = selectedRows[0];

            navigate(`/contacts/${currentRowId}`);

          }}
        >
          Редактировать контакт
        </Button> : ""
      }


      {selectedRows.length === 1 ?
        <Button
          sx={{

            color: "white",
            backgroundColor: "#16b8f3",
            orderTop: 20,
            left: 426,
            height: 40,
            position: "absolute",
            // transform: "translateY(-50%)",

            "&:hover": {
              backgroundColor: "#12a8df",
            },
          }}
          variant="contained"
          onClick={() => {

            let currentRowId = selectedRows[0];


            dispatch(contactsDataDeleteByID(currentRowId)).then(() => {

              if (clients1_id?.id) {
                dispatch(contactsData(clients1_id));
              } else {

                if (!clients1_id) {

                  dispatch(contactsData(clientEmpty)); // то что в экшине

                }
              }

            });

          }}
        >
          Удалить контакт
        </Button> : ""
      }

    </div>

  )
}

